import { DATASOURCE } from 'Constants'

const initialState = {
  data: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.LADDER.RESET:
      return {
        ...state,
        data:[],
        loading:false
      };
    case DATASOURCE.LADDER.KEY:
      return {
        ...state,
        data: loadData(action.data),
        loading: false
      };
    case DATASOURCE.LADDER.LOADING:
      return {
        ...state,
        data:[],
        loading:true
      };
    default:
      return state;
  }  
};

// Currently, all 0.0.0.0 messages are duplicates that are elsewhere. Filtering here.
function loadData(messages) {
  let retval = [];
  messages.forEach( message => {
    if (message.dst_ip !== "0.0.0.0" && message.src_ip !== "0.0.0.0") {
      retval.push(message);
    }
  });
  return retval;
}
